import * as registry from './pdf-tab-registry'
import * as sessionFlag from './session-flag'

// Public-API entry points composing registry + session flag. Kept in `model/`
// since they are pure state mutations with no UI concerns.

export function registerPdfTab(documentKey: string, win: Window | null): void {
  // Popup blocked or window.open otherwise returned null — nothing to track.
  if (!win) return
  registry.register(documentKey, win)
  sessionFlag.setOpened(documentKey)
}

export function clearPdfTab(documentKey: string): void {
  registry.forget(documentKey)
  sessionFlag.clear(documentKey)
}
